import { useEffect, useState } from 'react';
import { api, getSession } from '../api/client.ts';

interface Csb { id: string; nom: string; code: string | null; actif: boolean }
interface Dashboard {
  nbCsbActifs: number;
  nbUtilisateursActifs: number;
  consultationsEnAttenteSync: number;
  periodesParStatut: Record<string, number>;
  derniereSauvegarde: { nom_fichier: string; statut: string; terminee_le: string } | null;
  tentativesConnexionEchoueesDernieres24h: number;
}

export default function Parametres() {
  const session = getSession();
  const [csbs, setCsbs] = useState<Csb[]>([]);
  const [dashboard, setDashboard] = useState<Dashboard | null>(null);
  const [nomCsb, setNomCsb] = useState('');
  const [message, setMessage] = useState<string | null>(null);

  const [csbIdPourUser, setCsbIdPourUser] = useState('');
  const [nomUser, setNomUser] = useState('');
  const [emailUser, setEmailUser] = useState('');
  const [roleUser, setRoleUser] = useState<'RESPONSABLE_CSB' | 'AGENT_SAISIE'>('RESPONSABLE_CSB');

  useEffect(() => {
    if (session.role === 'ADMIN') {
      api.get<Csb[]>('/admin/csb').then(setCsbs);
      api.get<Dashboard>('/admin/dashboard').then(setDashboard);
    }
  }, []);

  if (session.role !== 'ADMIN') {
    return <p>Cet écran est réservé à l'administrateur. Contactez-le pour toute modification de compte ou de CSB.</p>;
  }

  async function creerCsb() {
    if (!nomCsb.trim()) return;
    const c = await api.post<Csb>('/admin/csb', { nom: nomCsb });
    setCsbs([...csbs, c]);
    setNomCsb('');
  }

  async function creerUtilisateur() {
    const res = await api.post<{ motDePasseTemporaire: string }>('/admin/users', {
      csbId: csbIdPourUser, role: roleUser, nom: nomUser, email: emailUser,
    });
    setMessage(`Compte créé. Mot de passe temporaire à communiquer une seule fois : ${res.motDePasseTemporaire}`);
    setNomUser(''); setEmailUser('');
  }

  return (
    <div>
      <h1>Paramètres — Administration</h1>

      {dashboard && (
        <div style={{ marginBottom: 24 }}>
          <h2>Tableau de bord</h2>
          <table>
            <tbody>
              <tr><td>CSB actifs</td><td>{dashboard.nbCsbActifs}</td></tr>
              <tr><td>Utilisateurs actifs</td><td>{dashboard.nbUtilisateursActifs}</td></tr>
              <tr><td>Consultations en attente de synchronisation</td><td>{dashboard.consultationsEnAttenteSync}</td></tr>
              <tr>
                <td>Dernière sauvegarde</td>
                <td>
                  {dashboard.derniereSauvegarde
                    ? `${dashboard.derniereSauvegarde.statut} — ${new Date(dashboard.derniereSauvegarde.terminee_le).toLocaleString('fr-FR')}`
                    : 'Aucune sauvegarde enregistrée'}
                </td>
              </tr>
              <tr><td>Tentatives de connexion échouées (24h)</td><td>{dashboard.tentativesConnexionEchoueesDernieres24h}</td></tr>
            </tbody>
          </table>
        </div>
      )}

      <h2>Créer un CSB</h2>
      <input placeholder="Nom du CSB" value={nomCsb} onChange={(e) => setNomCsb(e.target.value)} />
      <div style={{ marginTop: 12 }}><button onClick={creerCsb}>Créer le CSB</button></div>

      <h2>Créer un compte pour un CSB</h2>
      <label>CSB</label>
      <select value={csbIdPourUser} onChange={(e) => setCsbIdPourUser(e.target.value)}>
        <option value="">—</option>
        {csbs.map((c) => <option key={c.id} value={c.id}>{c.nom}</option>)}
      </select>
      <label>Rôle</label>
      <select value={roleUser} onChange={(e) => setRoleUser(e.target.value as any)}>
        <option value="RESPONSABLE_CSB">Responsable CSB</option>
        <option value="AGENT_SAISIE">Agent de saisie</option>
      </select>
      <label>Nom</label>
      <input value={nomUser} onChange={(e) => setNomUser(e.target.value)} />
      <label>Email</label>
      <input type="email" value={emailUser} onChange={(e) => setEmailUser(e.target.value)} />
      <div style={{ marginTop: 12 }}><button onClick={creerUtilisateur} disabled={!csbIdPourUser || !nomUser || !emailUser}>Créer le compte</button></div>

      {message && <p style={{ marginTop: 16, wordBreak: 'break-all' }}>{message}</p>}

      <h2>CSB existants</h2>
      <table>
        <thead><tr><th>Nom</th><th>Actif</th></tr></thead>
        <tbody>{csbs.map((c) => <tr key={c.id}><td>{c.nom}</td><td>{c.actif ? 'Oui' : 'Non'}</td></tr>)}</tbody>
      </table>
    </div>
  );
}
